import { images, stats } from "@/data";

const Stats = () => {
  return (
    <section className="stats section">
      <div className="container">
        <div className="stats__grid">
          {stats.map((s) => (
            <div className="stats__item" key={s.value}>
              <img className="stats__icon" src={images.leafIcon} alt="" aria-hidden="true" />
              <div className="stats__value">{s.value}</div>
              <h3 className="stats__title">{s.title}</h3>
              <p className="stats__desc">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
